module.exports = __webpack_public_path__ + "media/images/downy-cd9027752dbe7efde20294a4c48fa7dc.png";